<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Smpp_Service_Host')"
      prop="service_host"
    >
      <el-input
        v-model="model.params.service_host"
        :placeholder="$t('ChannelConfig_Smpp_Service_Host')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Smpp_Service_Port')"
      prop="service_port"
    >
      <el-input
        v-model="model.params.service_port"
        :placeholder="$t('ChannelConfig_Smpp_Service_Port')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Smpp_Host')" prop="host">
      <el-input
        v-model="model.params.host"
        :placeholder="$t('ChannelConfig_Smpp_Host')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Smpp_Port')" prop="port">
      <el-input
        v-model="model.params.port"
        :placeholder="$t('ChannelConfig_Smpp_Port')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Smpp_System_Id')"
      prop="system_id"
    >
      <el-input
        v-model="model.params.system_id"
        :placeholder="$t('ChannelConfig_Smpp_System_Id')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Smpp_Password')" prop="password">
      <el-input
        v-model="model.params.password"
        :placeholder="$t('ChannelConfig_Smpp_Password')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Smpp_IgnorePermanentBounce')"
      prop="ignore_permanent_bounce"
    >
      <rest-form-select-boolean
        v-model="model.params.ignore_permanent_bounce"
      />
    </rest-form-item>
    <rest-form-item
      v-if="model.id"
      :label="$t('ChannelConfig_Smpp_AuthKey')"
      prop="auth_key"
    >
      <el-input
        readonly
        v-model="model.params.auth_key"
        :placeholder="$t('ChannelConfig_Smpp_AuthKey_Description')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestFormSelectBoolean from '@/common/components/rest/RestFormSelectBoolean'

export default {
  components: { RestFormItem, RestFormSelectBoolean },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'smpp')
      this.$set(this.model, 'params', { ignore_permanent_bounce: 0 })
    } else {
      const params = this.model.params || {}

      if (!Object.hasOwn(params, 'ignore_permanent_bounce')) {
        this.$set(this.model, 'params', {
          ...params,
          ignore_permanent_bounce: 0
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Smpp.vue